import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';

import { ListButtonsColumn } from '../../../../modules/dashboard/lists/ListButtonsColumn';
import { useModalContext } from '../../../../hooks/useModal';
import { TertiaryButton } from '../../../../ui-kit/TertiaryButton';
import { PrimaryButton } from '../../../../ui-kit/PrimaryButton';
import { useConfiguredAutomationsQuery } from '../../../../hooks/yldr/useConfiguredAutomationsQuery';
import { EControlPositionType } from '../../../../types/uniswapTokens';

export interface ILeverageActionsProps {
  marketId?: number;
  positionAddress?: string;
  controlType?: EControlPositionType;
  disabled?: boolean;
}

export const LeveragedActions = ({ marketId, positionAddress, controlType }: ILeverageActionsProps) => {
  const { breakpoints } = useTheme();
  const md = useMediaQuery(breakpoints.up('md'));

  return md ? (
    <ListButtonsColumn size="big">
      <ActionsButton positionAddress={positionAddress} controlType={controlType} />
      <AutomationsButton
        marketId={marketId}
        positionAddress={positionAddress}
        disabled={controlType === EControlPositionType.AlmPosition}
      />
    </ListButtonsColumn>
  ) : (
    <>
      <ActionsButton positionAddress={positionAddress} controlType={controlType} />
      <AutomationsButton
        marketId={marketId}
        positionAddress={positionAddress}
        disabled={controlType === EControlPositionType.AlmPosition}
      />
    </>
  );
};

export const ActionsButton = ({ positionAddress, controlType }: ILeverageActionsProps) => {
  const { openActions } = useModalContext();
  return (
    <PrimaryButton
      onClick={() => positionAddress && openActions(positionAddress, controlType)}
    >
      Actions
    </PrimaryButton>
  );
};

export const AutomationsButton = ({ marketId, positionAddress, disabled }: ILeverageActionsProps) => {
  const { openAutomations } = useModalContext();
  const { data: configuredAutomationsData } = useConfiguredAutomationsQuery({
    marketId: marketId,
    positions: positionAddress ? [positionAddress] : undefined,
  });

  const initializedAutomations =
    configuredAutomationsData?.compounds[0].initialized ||
    configuredAutomationsData?.rebalances[0].initialized ||
    configuredAutomationsData?.deleverages[0].initialized;

  return (
    <TertiaryButton
      onClick={() => positionAddress && marketId && openAutomations(marketId, positionAddress)}
      disabled={disabled}
    >
      Automations
      {initializedAutomations && (
        <Box sx={{
          position: 'absolute',
          top: '-3px',
          right: '-3px',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: '#AFF113',
        }} />
      )}
    </TertiaryButton>
  );
};
